var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("div", { staticClass: "row" }, [
      _c(
        "div",
        { staticClass: "col-md-6" },
        [
          _c("div", { staticClass: "flex" }, [
            _c(
              "select",
              {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.filter.type,
                    expression: "filter.type",
                  },
                ],
                staticClass: "form-control",
                on: {
                  change: [
                    function ($event) {
                      var $$selectedVal = Array.prototype.filter
                        .call($event.target.options, function (o) {
                          return o.selected
                        })
                        .map(function (o) {
                          var val = "_value" in o ? o._value : o.value
                          return val
                        })
                      _vm.$set(
                        _vm.filter,
                        "type",
                        $event.target.multiple
                          ? $$selectedVal
                          : $$selectedVal[0]
                      )
                    },
                    function ($event) {
                      return _vm.updateComponent(false, true)
                    },
                  ],
                },
              },
              _vm._l(_vm.searchTypeOptions, function (type) {
                return _c("option", { domProps: { value: type.typeId } }, [
                  _vm._v(_vm._s(type.title) + "\n          "),
                ])
              }),
              0
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "width50" },
              [
                _vm.filter.type == 5
                  ? [
                      _c(
                        "div",
                        { staticClass: "form-group m-0" },
                        [
                          _c("DateSelectProps", {
                            attrs: {
                              selectedDate: _vm.searchFilter.c1.date,
                              onSelect: (date) => _vm.dateSelected(date),
                            },
                          }),
                        ],
                        1
                      ),
                    ]
                  : _vm._e(),
                _vm._v(" "),
                _c(_vm.searchTypeComponent, {
                  ref: "searchValue",
                  tag: "component",
                  attrs: {
                    updateFilter: _vm.updateFilter,
                    type: _vm.filter.type,
                    setValue: _vm.filter.searchData,
                  },
                }),
              ],
              2
            ),
          ]),
          _vm._v(" "),
          _vm.filter.type != 5
            ? _c("div", { staticClass: "form-group" }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.searchFilter.c1.active,
                      expression: "searchFilter.c1.active",
                    },
                  ],
                  attrs: { type: "checkbox", id: "ch_3" },
                  domProps: {
                    checked: Array.isArray(_vm.searchFilter.c1.active)
                      ? _vm._i(_vm.searchFilter.c1.active, null) > -1
                      : _vm.searchFilter.c1.active,
                  },
                  on: {
                    change: function ($event) {
                      var $$a = _vm.searchFilter.c1.active,
                        $$el = $event.target,
                        $$c = $$el.checked ? true : false
                      if (Array.isArray($$a)) {
                        var $$v = null,
                          $$i = _vm._i($$a, $$v)
                        if ($$el.checked) {
                          $$i < 0 &&
                            _vm.$set(
                              _vm.searchFilter.c1,
                              "active",
                              $$a.concat([$$v])
                            )
                        } else {
                          $$i > -1 &&
                            _vm.$set(
                              _vm.searchFilter.c1,
                              "active",
                              $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                            )
                        }
                      } else {
                        _vm.$set(_vm.searchFilter.c1, "active", $$c)
                      }
                    },
                  },
                }),
                _vm._v(" "),
                _c("label", { attrs: { for: "ch_3" } }, [
                  _vm._v(" показать с актуальностью сроков годности"),
                ]),
              ])
            : _vm._e(),
          _vm._v(" "),
          _c("div", { staticClass: "flex" }, [
            _c("div", { staticClass: "form-group mr-5" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.searchFilter.c1.search_order,
                    expression: "searchFilter.c1.search_order",
                  },
                ],
                attrs: {
                  type: "radio",
                  disabled: !_vm.searchFilter.c1.active,
                  value: "before",
                  name: "rb",
                  id: "ra_1",
                },
                domProps: {
                  checked: _vm._q(_vm.searchFilter.c1.search_order, "before"),
                },
                on: {
                  change: function ($event) {
                    return _vm.$set(
                      _vm.searchFilter.c1,
                      "search_order",
                      "before"
                    )
                  },
                },
              }),
              _vm._v(" "),
              _c("label", { attrs: { for: "ra_1" } }, [_vm._v(" до")]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "form-group" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.searchFilter.c1.search_order,
                    expression: "searchFilter.c1.search_order",
                  },
                ],
                attrs: {
                  type: "radio",
                  disabled: !_vm.searchFilter.c1.active,
                  value: "after",
                  name: "rb",
                  id: "ra_2",
                },
                domProps: {
                  checked: _vm._q(_vm.searchFilter.c1.search_order, "after"),
                },
                on: {
                  change: function ($event) {
                    return _vm.$set(
                      _vm.searchFilter.c1,
                      "search_order",
                      "after"
                    )
                  },
                },
              }),
              _vm._v(" "),
              _c("label", { attrs: { for: "ra_2" } }, [_vm._v(" после")]),
            ]),
          ]),
          _vm._v(" "),
          _vm.filter.type != 5
            ? [
                _c(
                  "div",
                  { staticClass: "form-group" },
                  [
                    _c("DateSelectProps", {
                      ref: "calendar",
                      attrs: {
                        selectedDate: _vm.currentDate,
                        onSelect: (date) => _vm.dateSelected(date),
                      },
                    }),
                  ],
                  1
                ),
              ]
            : _vm._e(),
          _vm._v(" "),
          _c("div", { staticClass: "input_100" }, [
            _c("div", { staticClass: "flex" }, [
              _c("span", [_vm._v("Рассчитавать по курсу")]),
              _vm._v(" "),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.profitCalculation.calculatedRate,
                    expression: "profitCalculation.calculatedRate",
                  },
                ],
                staticClass: "form-control",
                attrs: { type: "text" },
                domProps: { value: _vm.profitCalculation.calculatedRate },
                on: {
                  input: function ($event) {
                    if ($event.target.composing) return
                    _vm.$set(
                      _vm.profitCalculation,
                      "calculatedRate",
                      $event.target.value
                    )
                  },
                },
              }),
              _vm._v(" "),
              _c("span", [_vm._v("(базовый курс")]),
              _vm._v(" "),
              _c("input", {
                staticClass: "form-control",
                attrs: { disabled: "", type: "text" },
                domProps: { value: 1 / _vm.$AllCurrencies[33].rate },
              }),
              _vm._v(" "),
              _c("span", [_vm._v("+ коэффициент")]),
              _vm._v(" "),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.profitCalculation.ratePercent,
                    expression: "profitCalculation.ratePercent",
                  },
                ],
                staticClass: "form-control",
                attrs: { type: "text" },
                domProps: { value: _vm.profitCalculation.ratePercent },
                on: {
                  input: function ($event) {
                    if ($event.target.composing) return
                    _vm.$set(
                      _vm.profitCalculation,
                      "ratePercent",
                      $event.target.value
                    )
                  },
                },
              }),
              _vm._v(" "),
              _c("span", [_vm._v("%)")]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "flex" }, [
              _c("span", [
                _vm._v("С расходами на доставку (вычит. из кон. суммы)"),
              ]),
              _vm._v(" "),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.profitCalculation.deliveryPercent,
                    expression: "profitCalculation.deliveryPercent",
                  },
                ],
                staticClass: "form-control",
                attrs: { type: "text" },
                domProps: { value: _vm.profitCalculation.deliveryPercent },
                on: {
                  input: function ($event) {
                    if ($event.target.composing) return
                    _vm.$set(
                      _vm.profitCalculation,
                      "deliveryPercent",
                      $event.target.value
                    )
                  },
                },
              }),
              _vm._v(" "),
              _c("span", [_vm._v("% и")]),
              _vm._v(" "),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.profitCalculation.delivery,
                    expression: "profitCalculation.delivery",
                  },
                ],
                staticClass: "form-control",
                attrs: { type: "text" },
                domProps: { value: _vm.profitCalculation.delivery },
                on: {
                  input: function ($event) {
                    if ($event.target.composing) return
                    _vm.$set(
                      _vm.profitCalculation,
                      "delivery",
                      $event.target.value
                    )
                  },
                },
              }),
              _vm._v(" "),
              _c("span", [_vm._v("руб.")]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "flex" }, [
              _c("span", [_vm._v("БАЗОВАЯ НАЦЕНКА")]),
              _vm._v(" "),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.profitCalculation.baseMargin,
                    expression: "profitCalculation.baseMargin",
                  },
                ],
                staticClass: "form-control",
                attrs: { type: "text" },
                domProps: { value: _vm.profitCalculation.baseMargin },
                on: {
                  input: function ($event) {
                    if ($event.target.composing) return
                    _vm.$set(
                      _vm.profitCalculation,
                      "baseMargin",
                      $event.target.value
                    )
                  },
                },
              }),
              _vm._v(" "),
              _c("span", [_vm._v("процентов")]),
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "mb-2" },
              [
                _c("label", { attrs: { for: "" } }, [
                  _vm._v("Предустановленные данные"),
                ]),
                _vm._v(" "),
                _c("RatePreSet", {
                  attrs: {
                    customData: _vm.profitCalculation,
                    update: (data) => (this.profitCalculation = data),
                  },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c("div", { staticClass: "mb-2" }, [
              _c("label", { attrs: { for: "" } }, [
                _vm._v("Сортировка по закупке"),
              ]),
              _vm._v(" "),
              _c(
                "select",
                {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.extraSearchOptions.sorting.purchaseQty,
                      expression: "extraSearchOptions.sorting.purchaseQty",
                    },
                  ],
                  staticClass: "form-control",
                  on: {
                    change: function ($event) {
                      var $$selectedVal = Array.prototype.filter
                        .call($event.target.options, function (o) {
                          return o.selected
                        })
                        .map(function (o) {
                          var val = "_value" in o ? o._value : o.value
                          return val
                        })
                      _vm.$set(
                        _vm.extraSearchOptions.sorting,
                        "purchaseQty",
                        $event.target.multiple
                          ? $$selectedVal
                          : $$selectedVal[0]
                      )
                    },
                  },
                },
                [
                  _c("option", { attrs: { value: "0" } }, [
                    _vm._v("Без сортировки"),
                  ]),
                  _vm._v(" "),
                  _c("option", { attrs: { value: "1" } }, [
                    _vm._v("Наибольшая продажа"),
                  ]),
                  _vm._v(" "),
                  _c("option", { attrs: { value: "2" } }, [
                    _vm._v("Наименьшая продажа"),
                  ]),
                  _vm._v(" "),
                  _c("option", { attrs: { value: "3" } }, [
                    _vm._v("Наибольшая закупка"),
                  ]),
                  _vm._v(" "),
                  _c("option", { attrs: { value: "4" } }, [
                    _vm._v("Наименьшая закупка"),
                  ]),
                ]
              ),
            ]),
          ]),
        ],
        2
      ),
      _vm._v(" "),
      _c("div", { staticClass: "col-md-6" }, [
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col-md-6" }, [
            _vm._m(0),
            _vm._v(" "),
            _vm._m(1),
            _vm._v(" "),
            _c("div", { staticClass: "form-group" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.filter.c3,
                    expression: "filter.c3",
                  },
                ],
                attrs: { type: "checkbox", id: "ch_4" },
                domProps: {
                  checked: Array.isArray(_vm.filter.c3)
                    ? _vm._i(_vm.filter.c3, null) > -1
                    : _vm.filter.c3,
                },
                on: {
                  change: function ($event) {
                    var $$a = _vm.filter.c3,
                      $$el = $event.target,
                      $$c = $$el.checked ? true : false
                    if (Array.isArray($$a)) {
                      var $$v = null,
                        $$i = _vm._i($$a, $$v)
                      if ($$el.checked) {
                        $$i < 0 && _vm.$set(_vm.filter, "c3", $$a.concat([$$v]))
                      } else {
                        $$i > -1 &&
                          _vm.$set(
                            _vm.filter,
                            "c3",
                            $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                          )
                      }
                    } else {
                      _vm.$set(_vm.filter, "c3", $$c)
                    }
                  },
                },
              }),
              _vm._v(" "),
              _c("label", { attrs: { for: "ch_4" } }, [
                _vm._v(" показать себестоимость в рублях"),
              ]),
            ]),
            _vm._v(" "),
            _c("div", [
              _c("div", { staticClass: "custom-control custom-radio" }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.filter.c4,
                      expression: "filter.c4",
                    },
                  ],
                  staticClass: "custom-control-input",
                  attrs: { type: "radio", id: "rr1", value: "0" },
                  domProps: { checked: _vm._q(_vm.filter.c4, "0") },
                  on: {
                    change: function ($event) {
                      return _vm.$set(_vm.filter, "c4", "0")
                    },
                  },
                }),
                _vm._v(" "),
                _c(
                  "label",
                  {
                    staticClass: "custom-control-label",
                    attrs: { for: "rr1" },
                  },
                  [_vm._v(" без учета ЕГК")]
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "custom-control custom-radio" }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.filter.c4,
                      expression: "filter.c4",
                    },
                  ],
                  staticClass: "custom-control-input",
                  attrs: { type: "radio", id: "rr2", value: "1" },
                  domProps: { checked: _vm._q(_vm.filter.c4, "1") },
                  on: {
                    change: function ($event) {
                      return _vm.$set(_vm.filter, "c4", "1")
                    },
                  },
                }),
                _vm._v(" "),
                _c(
                  "label",
                  {
                    staticClass: "custom-control-label",
                    attrs: { for: "rr2" },
                  },
                  [_vm._v(" показать только препараты с ЕГК")]
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "custom-control custom-radio" }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.filter.c4,
                      expression: "filter.c4",
                    },
                  ],
                  staticClass: "custom-control-input",
                  attrs: { type: "radio", id: "rr3", value: "2" },
                  domProps: { checked: _vm._q(_vm.filter.c4, "2") },
                  on: {
                    change: function ($event) {
                      return _vm.$set(_vm.filter, "c4", "2")
                    },
                  },
                }),
                _vm._v(" "),
                _c(
                  "label",
                  {
                    staticClass: "custom-control-label",
                    attrs: { for: "rr3" },
                  },
                  [_vm._v(" показать только препараты с активными кодами ЕГК")]
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "custom-control custom-radio" }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.filter.c4,
                      expression: "filter.c4",
                    },
                  ],
                  staticClass: "custom-control-input",
                  attrs: { type: "radio", id: "rr4", value: "3" },
                  domProps: { checked: _vm._q(_vm.filter.c4, "3") },
                  on: {
                    change: function ($event) {
                      return _vm.$set(_vm.filter, "c4", "3")
                    },
                  },
                }),
                _vm._v(" "),
                _c(
                  "label",
                  {
                    staticClass: "custom-control-label",
                    attrs: { for: "rr4" },
                  },
                  [
                    _vm._v(
                      " показать только препараты с НЕ активными кодами\n                ЕГК"
                    ),
                  ]
                ),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "form-group" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.filter.c11,
                    expression: "filter.c11",
                  },
                ],
                attrs: { type: "checkbox", id: "ch_11" },
                domProps: {
                  checked: Array.isArray(_vm.filter.c11)
                    ? _vm._i(_vm.filter.c11, null) > -1
                    : _vm.filter.c11,
                },
                on: {
                  change: function ($event) {
                    var $$a = _vm.filter.c11,
                      $$el = $event.target,
                      $$c = $$el.checked ? true : false
                    if (Array.isArray($$a)) {
                      var $$v = null,
                        $$i = _vm._i($$a, $$v)
                      if ($$el.checked) {
                        $$i < 0 &&
                          _vm.$set(_vm.filter, "c11", $$a.concat([$$v]))
                      } else {
                        $$i > -1 &&
                          _vm.$set(
                            _vm.filter,
                            "c11",
                            $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                          )
                      }
                    } else {
                      _vm.$set(_vm.filter, "c11", $$c)
                    }
                  },
                },
              }),
              _vm._v(" "),
              _c("label", { attrs: { for: "ch_11" } }, [
                _vm._v(" препараты с коэффициентами"),
              ]),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-md-6" }, [
            _c("div", { staticClass: "custom-control custom-radio" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.extraSearchOptions.sold_filter,
                    expression: "extraSearchOptions.sold_filter",
                  },
                ],
                staticClass: "custom-control-input",
                attrs: { type: "radio", id: "sf_pch_1", value: "all_records" },
                domProps: {
                  checked: _vm._q(
                    _vm.extraSearchOptions.sold_filter,
                    "all_records"
                  ),
                },
                on: {
                  change: function ($event) {
                    return _vm.$set(
                      _vm.extraSearchOptions,
                      "sold_filter",
                      "all_records"
                    )
                  },
                },
              }),
              _vm._v(" "),
              _c(
                "label",
                {
                  staticClass: "custom-control-label",
                  attrs: { for: "sf_pch_1" },
                },
                [_vm._v(" все препараты")]
              ),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "custom-control custom-radio" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.extraSearchOptions.sold_filter,
                    expression: "extraSearchOptions.sold_filter",
                  },
                ],
                staticClass: "custom-control-input",
                attrs: { type: "radio", id: "sf_pch_2", value: "sold_only" },
                domProps: {
                  checked: _vm._q(
                    _vm.extraSearchOptions.sold_filter,
                    "sold_only"
                  ),
                },
                on: {
                  change: function ($event) {
                    return _vm.$set(
                      _vm.extraSearchOptions,
                      "sold_filter",
                      "sold_only"
                    )
                  },
                },
              }),
              _vm._v(" "),
              _c(
                "label",
                {
                  staticClass: "custom-control-label",
                  attrs: { for: "sf_pch_2" },
                },
                [
                  _vm._v(
                    " есть продажи за посл. " +
                      _vm._s(_vm.lastStoreRev?.int_data ?? 4) +
                      " мес"
                  ),
                ]
              ),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "custom-control custom-radio" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.extraSearchOptions.sold_filter,
                    expression: "extraSearchOptions.sold_filter",
                  },
                ],
                staticClass: "custom-control-input",
                attrs: {
                  type: "radio",
                  id: "sf_pch_3",
                  value: "in_store_no_sale",
                },
                domProps: {
                  checked: _vm._q(
                    _vm.extraSearchOptions.sold_filter,
                    "in_store_no_sale"
                  ),
                },
                on: {
                  change: function ($event) {
                    return _vm.$set(
                      _vm.extraSearchOptions,
                      "sold_filter",
                      "in_store_no_sale"
                    )
                  },
                },
              }),
              _vm._v(" "),
              _c(
                "label",
                {
                  staticClass: "custom-control-label",
                  attrs: { for: "sf_pch_3" },
                },
                [_vm._v(" на складе есть, продаж нет")]
              ),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "custom-control custom-radio" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.extraSearchOptions.sold_filter,
                    expression: "extraSearchOptions.sold_filter",
                  },
                ],
                staticClass: "custom-control-input",
                attrs: {
                  type: "radio",
                  id: "sf_pch_4",
                  value: "out_store_no_sale",
                },
                domProps: {
                  checked: _vm._q(
                    _vm.extraSearchOptions.sold_filter,
                    "out_store_no_sale"
                  ),
                },
                on: {
                  change: function ($event) {
                    return _vm.$set(
                      _vm.extraSearchOptions,
                      "sold_filter",
                      "out_store_no_sale"
                    )
                  },
                },
              }),
              _vm._v(" "),
              _c(
                "label",
                {
                  staticClass: "custom-control-label",
                  attrs: { for: "sf_pch_4" },
                },
                [_vm._v(" на складе нет, продаж нет")]
              ),
            ]),
            _vm._v(" "),
            _vm.lastStoreRev?.id
              ? _c(
                  "div",
                  { staticClass: "alert alert-info" },
                  [
                    _c("p", [
                      _vm._v(
                        "Слепок наличия на складах + продажи\n              "
                      ),
                      _c("strong", [
                        _vm._v(
                          _vm._s(
                            _vm.printDate(
                              _vm.lastStoreRev.actual_date,
                              "DD.MM.YYYY HH:mm"
                            )
                          )
                        ),
                      ]),
                      _vm._v(
                        " (" + _vm._s(_vm.lastStoreRev.int_data) + " мес.)"
                      ),
                    ]),
                    _vm._v(" "),
                    _vm._m(2),
                    _vm._v(" "),
                    _c("LoadingButton", {
                      attrs: {
                        title: "Сделать слепок продаж",
                        className: "btn btn-xs btn-outline-info mt-1",
                        onClick: () => _vm.saveStoreStatus(),
                        loading: _vm.btnLoading.saveStoreStatus,
                        color: _vm.$constants.PRIMARY_COLOR,
                      },
                    }),
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _c("hr"),
            _vm._v(" "),
            _c("div", { staticClass: "form-group" }, [
              _c("label", [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.displaySettings.showIndPrice,
                      expression: "displaySettings.showIndPrice",
                    },
                  ],
                  attrs: { type: "checkbox" },
                  domProps: {
                    checked: Array.isArray(_vm.displaySettings.showIndPrice)
                      ? _vm._i(_vm.displaySettings.showIndPrice, null) > -1
                      : _vm.displaySettings.showIndPrice,
                  },
                  on: {
                    change: function ($event) {
                      var $$a = _vm.displaySettings.showIndPrice,
                        $$el = $event.target,
                        $$c = $$el.checked ? true : false
                      if (Array.isArray($$a)) {
                        var $$v = null,
                          $$i = _vm._i($$a, $$v)
                        if ($$el.checked) {
                          $$i < 0 &&
                            _vm.$set(
                              _vm.displaySettings,
                              "showIndPrice",
                              $$a.concat([$$v])
                            )
                        } else {
                          $$i > -1 &&
                            _vm.$set(
                              _vm.displaySettings,
                              "showIndPrice",
                              $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                            )
                        }
                      } else {
                        _vm.$set(_vm.displaySettings, "showIndPrice", $$c)
                      }
                    },
                  },
                }),
                _vm._v(
                  "\n              отображать индикативную цену\n            "
                ),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "form-group" }, [
              _c("label", [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.displaySettings.showDetailedPercentCalculation,
                      expression:
                        "displaySettings.showDetailedPercentCalculation",
                    },
                  ],
                  attrs: { type: "checkbox" },
                  domProps: {
                    checked: Array.isArray(
                      _vm.displaySettings.showDetailedPercentCalculation
                    )
                      ? _vm._i(
                          _vm.displaySettings.showDetailedPercentCalculation,
                          null
                        ) > -1
                      : _vm.displaySettings.showDetailedPercentCalculation,
                  },
                  on: {
                    change: function ($event) {
                      var $$a =
                          _vm.displaySettings.showDetailedPercentCalculation,
                        $$el = $event.target,
                        $$c = $$el.checked ? true : false
                      if (Array.isArray($$a)) {
                        var $$v = null,
                          $$i = _vm._i($$a, $$v)
                        if ($$el.checked) {
                          $$i < 0 &&
                            _vm.$set(
                              _vm.displaySettings,
                              "showDetailedPercentCalculation",
                              $$a.concat([$$v])
                            )
                        } else {
                          $$i > -1 &&
                            _vm.$set(
                              _vm.displaySettings,
                              "showDetailedPercentCalculation",
                              $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                            )
                        }
                      } else {
                        _vm.$set(
                          _vm.displaySettings,
                          "showDetailedPercentCalculation",
                          $$c
                        )
                      }
                    },
                  },
                }),
                _vm._v(
                  "\n              отображать просчет % наценки\n            "
                ),
              ]),
            ]),
          ]),
        ]),
        _vm._v(" "),
        _c("hr"),
        _vm._v(" "),
        _c("div", { staticClass: "form-group" }, [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.filter.c10,
                expression: "filter.c10",
              },
            ],
            attrs: { type: "checkbox", id: "ch_10" },
            domProps: {
              checked: Array.isArray(_vm.filter.c10)
                ? _vm._i(_vm.filter.c10, null) > -1
                : _vm.filter.c10,
            },
            on: {
              change: function ($event) {
                var $$a = _vm.filter.c10,
                  $$el = $event.target,
                  $$c = $$el.checked ? true : false
                if (Array.isArray($$a)) {
                  var $$v = null,
                    $$i = _vm._i($$a, $$v)
                  if ($$el.checked) {
                    $$i < 0 && _vm.$set(_vm.filter, "c10", $$a.concat([$$v]))
                  } else {
                    $$i > -1 &&
                      _vm.$set(
                        _vm.filter,
                        "c10",
                        $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                      )
                  }
                } else {
                  _vm.$set(_vm.filter, "c10", $$c)
                }
              },
            },
          }),
          _vm._v(" "),
          _c("label", { attrs: { for: "ch_10" } }, [
            _vm._v(
              " сортировать по наличию на складе МСК (max:Склад / min:Продажи)"
            ),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "flex custom_calculation" }, [
          _c(
            "select",
            {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.calculation.currency,
                  expression: "calculation.currency",
                },
              ],
              staticClass: "form-control",
              on: {
                change: [
                  function ($event) {
                    var $$selectedVal = Array.prototype.filter
                      .call($event.target.options, function (o) {
                        return o.selected
                      })
                      .map(function (o) {
                        var val = "_value" in o ? o._value : o.value
                        return val
                      })
                    _vm.$set(
                      _vm.calculation,
                      "currency",
                      $event.target.multiple ? $$selectedVal : $$selectedVal[0]
                    )
                  },
                  _vm.updateCalculation,
                ],
              },
            },
            _vm._l(_vm.$AllCurrencies, function (curr) {
              return _c("option", { domProps: { value: curr.id } }, [
                _vm._v(_vm._s(curr.currency)),
              ])
            }),
            0
          ),
          _vm._v(" "),
          _c("div", [
            _c("input", {
              staticClass: "form-control",
              attrs: { type: "number", disabled: "" },
              domProps: {
                value:
                  Math.round(
                    (1 / _vm.$AllCurrencies[_vm.calculation.currency].rate) *
                      10000
                  ) / 10000,
              },
            }),
          ]),
          _vm._v(" "),
          _c("div", [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.calculation.cost,
                  expression: "calculation.cost",
                },
              ],
              staticClass: "form-control",
              attrs: { placeholder: "Себестоимость", type: "text" },
              domProps: { value: _vm.calculation.cost },
              on: {
                change: _vm.updateCalculation,
                input: function ($event) {
                  if ($event.target.composing) return
                  _vm.$set(_vm.calculation, "cost", $event.target.value)
                },
              },
            }),
          ]),
          _vm._v(" "),
          _c("div", [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.calculation.price,
                  expression: "calculation.price",
                },
              ],
              staticClass: "form-control",
              attrs: { placeholder: "Стоимость", type: "number" },
              domProps: { value: _vm.calculation.price },
              on: {
                change: _vm.updateCalculation,
                input: function ($event) {
                  if ($event.target.composing) return
                  _vm.$set(_vm.calculation, "price", $event.target.value)
                },
              },
            }),
          ]),
          _vm._v(" "),
          _c("div", [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.calculation.percent,
                  expression: "calculation.percent",
                },
              ],
              staticClass: "form-control",
              attrs: { disabled: "", type: "text" },
              domProps: { value: _vm.calculation.percent },
              on: {
                input: function ($event) {
                  if ($event.target.composing) return
                  _vm.$set(_vm.calculation, "percent", $event.target.value)
                },
              },
            }),
          ]),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "mt-2" },
          [
            !_vm.showChangeDefaultSupplier
              ? [
                  _c("div", { staticClass: "text-right" }, [
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-default",
                        attrs: { type: "button" },
                        on: {
                          click: function ($event) {
                            _vm.showChangeDefaultSupplier = true
                          },
                        },
                      },
                      [
                        _vm._v(
                          "Сменить поставщика\n              по умолчанию\n            "
                        ),
                      ]
                    ),
                  ]),
                ]
              : [_c("SetDefaultSupplier")],
            _vm._v(" "),
            _c("div", { staticClass: "form-group mt-1" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.filter.showOrderedInvoices,
                    expression: "filter.showOrderedInvoices",
                  },
                ],
                attrs: { type: "checkbox", id: "ch_12" },
                domProps: {
                  checked: Array.isArray(_vm.filter.showOrderedInvoices)
                    ? _vm._i(_vm.filter.showOrderedInvoices, null) > -1
                    : _vm.filter.showOrderedInvoices,
                },
                on: {
                  change: function ($event) {
                    var $$a = _vm.filter.showOrderedInvoices,
                      $$el = $event.target,
                      $$c = $$el.checked ? true : false
                    if (Array.isArray($$a)) {
                      var $$v = null,
                        $$i = _vm._i($$a, $$v)
                      if ($$el.checked) {
                        $$i < 0 &&
                          _vm.$set(
                            _vm.filter,
                            "showOrderedInvoices",
                            $$a.concat([$$v])
                          )
                      } else {
                        $$i > -1 &&
                          _vm.$set(
                            _vm.filter,
                            "showOrderedInvoices",
                            $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                          )
                      }
                    } else {
                      _vm.$set(_vm.filter, "showOrderedInvoices", $$c)
                    }
                  },
                },
              }),
              _vm._v(" "),
              _c("label", { attrs: { for: "ch_12" } }, [
                _vm._v(" показать заказ препаратов"),
              ]),
            ]),
            _vm._v(" "),
            _vm.getTasksByType(17)
              ? _c(
                  "div",
                  { staticClass: "flex flex_gap_10 mb-2" },
                  [
                    _c("h4", { staticClass: "mb-0" }, [
                      _vm._v("у Вас "),
                      _c("strong", [
                        _vm._v(_vm._s(_vm.getTasksByType(17).total_tasks)),
                      ]),
                      _vm._v(" активных задач"),
                    ]),
                    _vm._v(" "),
                    _c("LoadingButton", {
                      attrs: {
                        title: "посмотреть",
                        type: "button",
                        loading: _vm.btnLoading.openTasks,
                        color: _vm.$constants.PRIMARY_COLOR,
                        onClick: () => _vm.openTasks(),
                        className: "btn btn-outline-info btn-xs",
                      },
                    }),
                  ],
                  1
                )
              : _vm._e(),
          ],
          2
        ),
      ]),
      _vm._v(" "),
      false
        ? _c("div", { staticClass: "col-md-12" }, [
            _c(
              "div",
              { staticClass: "letters_block" },
              _vm._l(_vm.rusArr, function (letter) {
                return _c(
                  "button",
                  {
                    staticClass: "btn btn-success",
                    attrs: { type: "button" },
                    on: {
                      click: function ($event) {
                        return _vm.searchByLetter(letter)
                      },
                    },
                  },
                  [_vm._v("\n          " + _vm._s(letter) + "\n        ")]
                )
              }),
              0
            ),
          ])
        : _vm._e(),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "form-group" }, [
      _c("input", { attrs: { type: "checkbox", id: "ch_1" } }),
      _vm._v(" "),
      _c("label", { attrs: { for: "ch_1" } }, [
        _vm._v(
          "показать неактивные препараты (найдено 0 неактивных препаратов с ненулевыми остатками на\n              складах)"
        ),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "form-group" }, [
      _c("input", { attrs: { type: "checkbox", id: "ch_2" } }),
      _vm._v(" "),
      _c("label", { attrs: { for: "ch_2" } }, [
        _vm._v(" показать ТОЛЬКО неактивные препараты"),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("p", [_c("i", [_vm._v("Все склады, кроме списания")])])
  },
]
render._withStripped = true

export { render, staticRenderFns }